<template>
  <div class="miya-home" id="miyaHome">
    <div class="home-hearder" :class="{ headerTop: scrollT !== 0 }">
      <div class="logo"></div>
      <span
        style="color: white;
    font-size: 19px;
    font-weight: bold;"
        >/&nbsp;&nbsp;Pilotle Inc</span
      >
      <div class="headMenu">
        <div class="list">
          <p
            class="item"
            v-for="(item, idx) in header"
            :key="'menu' + idx"
            :class="{ active: headIdx === idx }"
            @click.stop="clickMenu(idx)"
          >
            {{ item }}
          </p>
        </div>
      </div>
      <miya-lang></miya-lang>
      <div class="btns">
        <div v-if="!isLogin" class="btn login" @click.stop="clickLogin()">
          {{ $t("home.login") }}
        </div>
        <div v-if="!isLogin" class="btn signup" @click.stop="clickSignup()">
          {{ $t("home.signup") }}
        </div>
        <div
          v-if="isLogin"
          class="btn signup goDashboard"
          @click.stop="clickGoDashboard()"
        >
          {{ $t("home.bannerBtn") }}
        </div>
      </div>
    </div>
    <div class="home-banner">
      <div class="bg"></div>
      <div class="bg1"></div>
      <img class="bg2" src="@assets/images/login/bg.png" />
      <div class="bg3"></div>
      <div class="banner">
        <div class="left-title">
          <h1 class="title1 fontSH">
            {{ $t("home.banner1")
            }}<span class="title2">{{ $t("home.banner2") }}</span
            >{{ $t("home.banner3") }}
          </h1>
          <h1 class="title1 title11 fontSH">{{ $t("home.banner4") }}</h1>
          <div class="btn" @click.stop="clickGoDashboard()">
            <span>{{ $t("home.bannerBtn") }}</span
            ><i class="icon-right"></i>
          </div>
        </div>
        <div class="right-item">
          <div
            class="item"
            v-for="(item, idx) in bannerList"
            :key="'banner' + idx"
          >
            <i class="icon" :class="item.icon"></i>
            <div class="text">
              <p class="text1">{{ item.name }}</p>
              <p class="text2">
                {{ item.s1 }}<span>{{ item.s2 }}</span
                >{{ item.s3 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-services" id="home-services">
      <h1 class="title1 fontSH">{{ $t("home.sTitle") }}</h1>
      <div class="list-box">
        <div class="left-list">
          <div
            class="item"
            @mouseover="serviceIdx = idx"
            :class="{ active: serviceIdx === idx }"
            v-for="(item, idx) in serviceList"
            :key="'service' + idx"
          >
            <p class="name fontSH">{{ item.name }}</p>
            <p class="subname">{{ item.subname }}</p>
            <p class="subname">{{ item.subname1 }}</p>
          </div>
        </div>
        <div class="right-info">
          <div class="bg" :class="currentCard.icon"></div>
          <p class="title2 fontSH">{{ currentCard.name }}</p>
          <p class="subname">{{ currentCard.subname }}</p>
          <p class="subname">{{ currentCard.subname1 }}</p>
          <div class="list">
            <div
              class="item"
              v-for="(item, idx) in currentCard.list"
              :key="'s' + idx"
            >
              <i class="icon"></i>{{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-global" id="home-global">
      <div class="bg"></div>
      <h1 class="title1 fontSH">{{ $t("home.gTitle") }}</h1>
      <div class="list">
        <div
          class="item"
          :class="{ active: globalIdx === idx }"
          v-for="(item, idx) in globalList"
          :key="'global' + idx"
        >
          <p class="name">{{ item.name }}</p>
          <p class="countries">{{ item.countries }}</p>
        </div>
      </div>
      <global1 ref="global1"></global1>
    </div>
    <div class="home-price" id="home-price">
      <h1 class="title1 fontSH">{{ $t("home.pTitle") }}</h1>
      <div class="price-box">
        <div class="left-price">
          <div
            class="item"
            v-for="(item, idx) in priceList"
            :key="'price' + idx"
          >
            <div class="info-box">
              <div class="name-box">
                <p class="name">{{ item.name }}</p>
                <p class="line"></p>
                <div class="subname-box">
                  <i class="icon"></i>
                  <p class="subname">
                    {{ item.subname1 }}<span>{{ item.subname2 }}</span>
                  </p>
                </div>
              </div>
              <p class="describe">{{ item.describe }}</p>
              <div class="p-box">
                <div class="type">{{ item.type }}</div>
                <p class="usd">$</p>
                <p class="price1">{{ item.price1 }}</p>
                <p class="price2">{{ item.price2 }}</p>
                <p class="unit">{{ item.unit }}</p>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn" @click="clickBuy(item)">
                {{ $t("home.pBtnBuy") }}
              </div>
            </div>
          </div>
          <div class="payType">
            <p class="title2">{{ $t("home.pPayType") }}</p>
            <i class="img img1"></i>
            <i class="img img2"></i>
            <i class="img img3"></i>
            <i class="img img4"></i>
            <i class="img img5"></i>
          </div>
        </div>
        <div class="right-contact">
          <div class="bg"></div>
          <div class="bg1"></div>
          <p class="text">{{ $t("home.pContact") }}</p>
          <div class="btn" @click="dialogTableContact = true">
            {{ $t("home.pBtn") }}
          </div>
        </div>
      </div>
    </div>
    <div class="home-chosen" id="home-chosen">
      <h1 class="title1 fontSH">{{ $t("home.cTitle") }}</h1>
      <p class="title2">{{ $t("home.cSubtitle") }}</p>
      <div class="list">
        <div class="item">
          <i class="img img1"></i>
          <p class="name">{{ $t("home.cs1") }}</p>
        </div>
        <div class="item">
          <i class="img img2"></i>
          <p class="name">{{ $t("home.cs2") }}</p>
        </div>
        <div class="item">
          <i class="img img3"></i>
          <p class="name">{{ $t("home.cs3") }}</p>
        </div>
        <div class="item">
          <i class="img img4"></i>
          <p class="name">{{ $t("home.cs4") }}</p>
        </div>
      </div>
    </div>
    <div class="home-go" @click.stop="clickGoDashboard()">
      <span>{{ $t("home.goBtn") }}</span
      ><i class="arrow"></i>
    </div>
    <bottom-link></bottom-link>
    <!-- <contact></contact> -->
    <el-dialog
      :title="$t('pTraffic.contactTitle')"
      :visible.sync="dialogTableContact"
      width="240px"
    >
      <img class="vx" src="@assets/images/login/vx.png" />
    </el-dialog>
  </div>
</template>
<script>
import miyaLang from "@components/lang.vue";
import bottomLink from "@components/bottomLink.vue";
import global1 from "@components/global1.vue";
import contact from "@components/contact.vue";
import {ElMessageBox} from "element-ui";

export default {
  data() {
    return {
      header: [],
      bannerList: [],
      serviceList: [],
      globalList: [],
      priceList: [],
      headIdx: 0,
      serviceIdx: 0,
      currentCard: {},
      globalIdx: 0,
      isLogin: false,
      heightList: [],
      scrollT: 0,
      dialogTableContact: false,
    };
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    // this.$alert('由于服务器升级，近期如您遇到网站访问不了的情况，请访问www.miyaip.net进行代替\nDue to server upgrades, if you encounter a situation where you cannot access the website recently, please visit www.miyaip.net instead.', {
    //       confirmButtonText: '确定',
    //       callback: action => {
    //         // this.$message({
    //         //   type: 'info',
    //         //   message: `action: ${ action }`
    //         // });
    //       }
    //     });

    this.getData();
    this.init();
  },
  methods: {
    getData() {
      this.header = [
        this.$t("home.tab1"),
        this.$t("home.tab2"),
        this.$t("home.tab3"),
      ];
      this.bannerList = [
        {
          name: this.$t("home.bannerTitle1"),
          icon: "icon1",
          s1: this.$t("home.bannerSubtitle1"),
          s2: this.$t("home.bannerSubtitle1_1"),
          s3: this.$t("home.bannerSubtitle1_2"),
        },
        {
          name: this.$t("home.bannerTitle2"),
          icon: "icon2",
          s1: this.$t("home.bannerSubtitle2"),
          s2: this.$t("home.bannerSubtitle2_1"),
          s3: this.$t("home.bannerSubtitle2_2"),
        },
        {
          name: this.$t("home.bannerTitle3"),
          icon: "icon3",
          s1: this.$t("home.bannerSubtitle3"),
          s2: this.$t("home.bannerSubtitle3_1"),
          s3: this.$t("home.bannerSubtitle3_2"),
        },
      ];
      this.serviceList = [
        {
          name: this.$t("home.sTitle1"),
          subname: this.$t("home.sSubtitle1"),
          icon: "icon1",
          subname1: this.$t("home.sSubtitle1_1"),
          list: [
            this.$t("home.st1_1"),
            this.$t("home.st1_2"),
            this.$t("home.st1_3"),
          ],
        },
        {
          name: this.$t("home.sTitle2"),
          subname: this.$t("home.sSubtitle2"),
          icon: "icon2",
          subname1: "",
          list: [
            this.$t("home.st2_1"),
            this.$t("home.st2_2"),
            this.$t("home.st2_3"),
          ],
        },
        {
          name: this.$t("home.sTitle3"),
          subname: this.$t("home.sSubtitle3"),
          icon: "icon3",
          subname1: "",
          list: [
            this.$t("home.st3_1"),
            this.$t("home.st3_2"),
            this.$t("home.st3_3"),
          ],
        },
      ];
      this.currentCard = this.serviceList[this.serviceIdx];
      this.globalList = [
        {
          name: this.$t("home.gName1"),
          countries: this.$t("home.gCountries1"),
        },
        {
          name: this.$t("home.gName2"),
          countries: this.$t("home.gCountries2"),
        },
        {
          name: this.$t("home.gName3"),
          countries: this.$t("home.gCountries3"),
        },
        {
          name: this.$t("home.gName4"),
          countries: this.$t("home.gCountries4"),
        },
        {
          name: this.$t("home.gName5"),
          countries: this.$t("home.gCountries5"),
        },
        {
          name: this.$t("home.gName6"),
          countries: this.$t("home.gCountries6"),
        },
      ];
      this.priceList = [
        {
          name: this.$t("home.pTitle1"),
          itemType: "country",
          subname1: this.$t("home.pSubtitile1"),
          subname2: this.$t("home.pSubtitile1_1"),
          describe: this.$t("home.pDescribe1"),
          type: this.$t("home.pType1"),
          price1: 8,
          price2: ".00",
          unit: this.$t("home.pUnit1"),
        },
        {
          name: this.$t("home.pTitle1"),
          itemType: "city",
          subname1: this.$t("home.pSubtitile2"),
          subname2: this.$t("home.pSubtitile2_1"),
          describe: this.$t("home.pDescribe1"),
          type: this.$t("home.pType1"),
          price1: 12,
          price2: ".00",
          unit: this.$t("home.pUnit1"),
        },
        {
          name: this.$t("home.pTitle3"),
          itemType: "ispone",
          subname1: this.$t("home.pSubtitile3"),
          subname2: this.$t("home.pSubtitile3_1"),
          describe: this.$t("home.pDescribe3"),
          type: this.$t("home.pType3"),
          price1: 6,
          price2: ".00",
          unit: this.$t("home.pUnit3"),
        },
        {
          name: this.$t("home.pTitle3"),
          itemType: "ispshare",
          subname1: this.$t("home.pSubtitile4"),
          subname2: this.$t("home.pSubtitile4_1"),
          describe: this.$t("home.pDescribe3"),
          type: this.$t("home.pType3"),
          price1: 3,
          price2: ".00",
          unit: this.$t("home.pUnit3"),
        },
      ];
      this.heightList = [
        $(".home-global").offset().top - 72,
        $(".home-price").offset().top - 72,
      ];
    },
    clickBuy(item) {
      if (this.isLogin) {
        if (item.itemType === "country" || item.itemType === "city") {
          this.$router.push({
            path: "/purchaseTraffic",
            query: { type: item.itemType },
          });
        } else if (item.itemType === "ispone" || item.itemType === "ispshare") {
          this.$router.push({
            path: "/purchaseAgent",
            query: { type: item.itemType },
          });
        }
      } else {
        this.$router.push("/login");
      }
    },
    getUserInfo() {
      this.$get("/Check/GetStatus").then((res) => {
        if (res.code === 200) {
          this.isLogin = true;
        }
      });
    },
    init() {
      this.timer = setInterval(() => {
        this.serviceIdx =
          this.serviceIdx + 1 === this.serviceList.length
            ? 0
            : this.serviceIdx + 1;
        this.globalIdx =
          this.globalIdx + 1 === this.globalList.length
            ? 0
            : this.globalIdx + 1;
        this.$refs.global1.changeMap(this.globalIdx);
      }, 5000);
      $(window).bind("scroll", (e) => {
        this.scrollSetMenu();
      });
    },
    scrollSetMenu() {
      this.scrollT = $(window).scrollTop();
      if (this.scrollT >= 0 && this.scrollT <= this.heightList[0]) {
        this.headIdx = 0;
      } else if (
        this.scrollT > this.heightList[0] &&
        this.scrollT < this.heightList[1]
      ) {
        this.headIdx = 1;
      } else if (this.scrollT >= this.heightList[1]) {
        this.headIdx = 2;
      }
    },
    clickMenu(num) {
      this.headIdx = num;
      let top = 0;
      if (num === 0) {
        top = 0;
        // top = $('.home-services').offset().top
      } else if (num === 1) {
        top = $(".home-global").offset().top - 72;
      } else if (num === 2) {
        top = $(".home-price").offset().top - +72;
      }
      $("html, body").animate({ scrollTop: top }, "slow");
    },
    clickLogin() {
      this.$router.push("/login");
    },
    clickSignup() {
      this.$router.push("/signup");
    },
    clickGoDashboard() {
      if (this.isLogin) {
        this.$router.push("/dashboard");
      } else {
        this.$message.error(this.$t("login.errorLogin"));
        this.$router.push("/login");
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    $(window).unbind("scroll");
  },
  watch: {
    language() {
      this.getData();
    },
    serviceIdx() {
      this.currentCard = this.serviceList[this.serviceIdx];
    },
  },
  components: { miyaLang, bottomLink, global1, contact },
};
</script>
<style scoped lang="stylus">
.miya-home
  position relative
  .home-hearder, .home-banner, .home-services, .home-chosen, .home-price, .home-global, .home-go
    min-width 1200px
  .home-chosen, .home-price, .home-global, .home-services
    .title1
      font-size 36px
      color $c1
      text-align center
  .home-hearder
    height 72px
    line-height 72px
    display flex
    position fixed
    top 0
    left 0
    width 100%
    z-index 10
    .logo
      width 106px
      height 30px
      background url('../../assets/images/home/miyaLOGO.svg') no-repeat center
      background-size 100% 100%
      margin 21px 0 0 48px
    .headMenu
      flex 1
      font-size $f16
      color $c78
      .list
        position absolute
        left 50%
        transform translate3d(-50%, 0,  0)
        display flex
        justify-content  center
        .item
          margin 0 45px
          cursor pointer
          &:hover
            color $c8
        .active
          position relative
          color $c8
          fontWeight()
          font-size $f18
          &:before
            content ''
            display block
            width 100%
            height 3px
            background-color $c8
            position absolute
            bottom 0
            left 0
    .btns
      margin 18px 48px
      display flex
      .btn
        font-size $f16
        border-radius 2px
        border 1px solid transparent
        line-height 36px
        cursor pointer
        width 108px
        text-align center
      .login
        border 1px solid $c7
        color $c7
        margin-right 32px
      .signup
        color $c1
        fontWeight()
        background: linear-gradient(95deg, $c8 0%, $c9 100%)
      .goDashboard
        width 180px
  .headerTop
    background-color $c1
  .home-banner
    padding 152px 0 108px 0
    background: linear-gradient(95deg, rgb(40,30,20) 0%, rgb(21,18,14 )  100%)
    position relative
    overflow hidden
    .bg, .bg1, .bg2, .bg3
      position absolute
      top 50%
      left 50%
      z-index 0
    .bg
      width 615px
      height 191px
      background url('../../assets/images/home/banner.png') no-repeat center
      background-size 100% 100%
      opacity 0.5
      transform translate3d(-50%, -50%, 0)
    .bg1
      top 0
      left 0
      width 690px
      height 497px
      background url('../../assets/images/home/bg1.png') no-repeat center
      background-size 100% 100%
      z-index 2
    .bg2
      bottom -50%
      left 50%
      transform translate3d(-50%,-10%,0)
      width 100%
      z-index 1
      opacity 0.3
    .bg3
      width 2500px
      height 1200px
      top 0
      left 0
      transform translate3d(-50%,-50%,0) rotate(45deg)
      background: radial-gradient(rgba(255,143,16,0.25), rgba(35,25,15,0), rgba(35,25,15,0))
      z-index 1
    .banner
      width 1200px
      margin 0 auto
      display flex
      .left-title
        width 650px
        margin-right 160px
        z-index 2
        .title1
          font-size 40px
          color $c7
          line-height 54px
          letter-spacing 2px
          margin-bottom 32px
        .title11
          margin-bottom 72px
        .title2
          color $c8
        .btn
          position absolute
          display flex
          padding 9px 20px
          border-radius 2px
          height 42px
          background url('../../assets/images/home/banner-btn.png') no-repeat
          background-size 100% 100%
          cursor pointer
          z-index 3
          fontWeight()
          span
            color $c1
            font-size $f18
            line-height 24px
            margin-right 19px
          .icon-right
            width 13px
            height 13px
            margin-top 6px
            background url('../../assets/images/home/btn-right.svg')
            background-size 100% 100%
      .right-item
        flex 1
        .item
          display flex
          .icon1
            background url('../../assets/images/home/icon1.png') no-repeat center
          .icon2
            background url('../../assets/images/home/icon2.png') no-repeat center
          .icon3
            background url('../../assets/images/home/icon3.png') no-repeat center
          .icon
            width 48px
            height 48px
            margin-right 20px
            background-size 100% 100%
          .text
            color $c7
            margin-bottom 67px
            flex 1
            .text1
              font-size $f20
              line-height 26px
              margin-bottom 12px
            .text2
              font-size $f16
              line-height 22px
              color #D6D6D6
              span
                color $c8
          &:last-child
            .text
              margin-bottom 0
  .home-services
    width 1200px
    padding 120px 0
    margin 0 auto
    .title1
      line-height 54px
      width 840px
      margin 0 auto 80px auto
    .list-box
      display flex
      .left-list
        width 400px
        display flex
        flex-direction column
        justify-content space-between
        border-right 2px solid $c11
        margin-right 46px
        .item
          color $c1
          flex 1
          display flex
          flex-direction column
          justify-content center
          .name
            font-size 26px
            margin-bottom 20px
          .subname
            font-size $f18
            color $c2
            line-height 26px
        .active
          position relative
          .name
            color $c8
          .subname
            color $c1
          &:before, &:after
            content ''
            display block
            position absolute
          &:before
            width 5px
            height 100%
            right -5px
            top 0
            background-color $c8
          &:after
            border 8px solid transparent
            border-left 8px solid $c8
            top calc(50% - 4px)
            right -21px
      .right-info
        flex 1
        height 480px
        background-color #F7F7F7
        padding 40px
        color $c1
        position relative
        .icon1
          background url('../../assets/images/home/s1.png')
        .icon2
          background url('../../assets/images/home/s2.png')
        .icon3
          background url('../../assets/images/home/s3.png')
        .bg
          position absolute
          right 20px
          bottom -20px
          width 226px
          height 226px
          background-size 100% 100%
          z-index 0
        .title2
          font-size 30px
          margin-bottom 20px
        .subname
          font-size $f20
          color $c2
          height 26px
          line-height 26px
        .list
          margin-top 64px
          position relative
          z-index 3
          .item
            margin-bottom 28px
            display flex
            line-height 32px
            font-size 22px
            .icon
              width 20px
              height 16px
              background url('../../assets/images/home/arrow.svg')
              background-size 100% 100%
              margin 8px 16px 8px 0
  .home-global
    background-color #F7F7F7
    padding 40px 0
    position relative
    overflow hidden
    .bg
      position absolute
      top 50%
      left 50%
      width 1904px
      height 1040px
      background url('../../assets/images/home/g-bg.png')
      background-size 100% 100%
      transform translate3d(-50%, -50%, 0)
      z-index 0
    .list
      width 1200px
      margin 120px auto 80px auto
      position relative
      z-index 1
      .item
        margin-bottom 36px
        color $c2
        .name
          line-height 24px
          margin-bottom 10px
          font-size $f18
        .countries
          font-size $f20
          line-height 32px
      .active
        .name
          color $c8
          fontWeight()
        .countries
          color $c1
          font-size 24px
          fontWeight()
  .home-price
    padding 80px 0 160px 0
    .price-box
      width 1200px
      margin 40px auto 0 auto
      display flex
      .left-price
        flex 1
        background: linear-gradient(86deg, #FFFFFF 0%, #F7F7F7 100%);
        .item
          display flex
          padding 16px 0 24px 0
          border-bottom 1px solid #D6D6D6
          margin-right 32px
          .info-box
            flex 1
            .name-box
              display flex
              color $c1
              line-height 28px
              margin-bottom 6px
              .name
                font-size 24px
                fontWeight()
              .line
                height 22px
                width 2px
                background-color $c12
                margin 3px 16px
              .subname-box
                display flex
                height 28px
                background-color rgba(255, 143, 16, 0.08)
                padding-right 12px
                .icon
                  width 26px
                  height 26px
                  background-size 100% 100%
                  margin 1px 4px 1px 0
                .subname
                  font-size $f16
                  span
                    color $c8
                    fontWeight()
            .describe
              font-size $f16
              color $c2
              margin-bottom 24px
              line-height 20px
            .p-box
              display flex
              color $c1
              line-height 24px
              .type
                width 65px
                height 24px
                line-height 24px
                color $c7
                font-size $f14
                padding-left 8px
                background url('../../assets/images/home/pType.png')
                background-size 100% 100%
                margin-right 20px
              .usd
                fontWeight()
                font-size $f20
                margin-right 6px
                line-height 22px
              .price1
                font-size 36px
                line-height 16px
              .price2
                font-size $f16
                line-height 30px
              .unit
                color $c2
                margin-left 4px
                line-height 30px
          &:nth-of-type(1)
            .icon
              background url('../../assets/images/home/price-icon1.png')
          &:nth-of-type(2)
            .icon
              background url('../../assets/images/home/price-icon2.png')
          &:nth-of-type(3)
            .icon
              background url('../../assets/images/home/price-icon3.png')
          &:nth-of-type(4)
            border-bottom none
            .icon
              background url('../../assets/images/home/price-icon4.png')
          .btn-box
            .btn
              color $c7
              font-size $f18
              border-radius 2px
              cursor pointer
              line-height 42px
              padding 0 18px
              background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
              &:hover
                box-shadow: 0px 8px 15px 1px rgba(255,201,159,0.6);
        .payType
          display flex
          padding 16px 32px
          background: linear-gradient(89deg, #F7F7F7 0%, #F0F0F0 100%);
          .title2
            font-size $f18
            fontWeight()
            color $c1
            padding-right 66px
            border-right 1px solid $c11
            line-height 48px
            margin-right 58px
          .img1
            background url('../../assets/images/home/pay1.png')
          .img2
            background url('../../assets/images/home/pay2.png')
          .img3
            background url('../../assets/images/home/pay3.png')
          .img4
            background url('../../assets/images/home/pay4.png')
          .img5
            background url('../../assets/images/home/pay5.png')
          .img
            width 48px
            height 48px
            margin-right 64px
            background-size 100% 100%
      .right-contact
        width 250px
        background: linear-gradient(180deg, #FF8F10 0%, #FF6F00 100%)
        position relative
        overflow hidden
        .bg, .text, .btn, .bg1
          position absolute
        .bg
          left 0
          bottom 0
          width 100%
          height 29.2%
          background url('../../assets/images/home/p-right-bg.png')
          background-size 100% 100%
        .bg1
          width 14.4%
          height 100%
          background: linear-gradient(90deg, rgba(175,76,0,0.4) 0%, rgba(255,122,6,0) 100%)
        .text, .btn
          left 50%
          width 80%
          fontWeight()
          text-align center
        .text
          font-size $f24
          font-weight 100
          color $c7
          line-height 32px
          top 50%
          transform translate3d(-50%, -50%, 0)
        .btn
          bottom 30px
          border-radius 2px
          background-color $c7
          line-height 42px
          color $c8
          cursor pointer
          font-size $f16
          transform translate3d(-50%, 0, 0)
  .home-chosen
    .title2
      color $c2
      font-size $f18
      text-align center
      line-height 26px
      margin 24px 0 80px 0
    .list
      width 1200px
      margin 0 auto 240px auto
      display flex
      .item
        flex 1
        .img1
          background url('../../assets/images/home/c1.png')
        .img2
          background url('../../assets/images/home/c2.png')
        .img3
          background url('../../assets/images/home/c3.png')
        .img4
          background url('../../assets/images/home/c4.png')
        .img
          width 96px
          height 96px
          display block
          margin 0 auto
          background-size 100% 100%
        .name
          color $c1
          font-size $f18
          line-height 24px
          margin-top 11px
          text-align center
          fontWeight()
  .home-go
    background: linear-gradient(88deg, #FF8F10 0%, #FF6F00 100%)
    padding 25px 0
    text-align center
    color $c7
    fontWeight()
    font-size $f24
    letter-spacing 2px
    display flex
    justify-content center
    cursor pointer
    .arrow
      margin 4px 0 0 24px
      width 24px
      height 18px
      background url('../../assets/images/home/go.png')
      background-size 100% 100%
  .vx
    display block
    margin 0 auto
@media screen and (max-width: 1200px)
  .miya-home
    .home-hearder, .home-banner, .home-services, .home-chosen, .home-price, .home-global, .home-go
      min-width 100%
    .home-chosen, .home-price, .home-global, .home-services
      .title1
        width 80%
        font-size 0.9rem
        line-height 1.4rem
        margin 0 auto
    .home-hearder
      .logo
        margin-left 1rem
      .headMenu
        .list
          left 40%
          .item
            margin 0 0.5rem
      .btns
        margin 18px 1rem
        .btn
          width 2rem
        .login
          margin-right 0.5rem
    .home-banner
      padding 3rem 0 2rem 0
      .bg
        width 8rem
        height 2rem
      .bg1
        width 7rem
        height 5rem
      .bg3
        width 25rem
        height 12rem
      .banner
        width 100%
        margin 0 0.5rem
        .left-title
          width 8rem
          margin-right 1rem
          .title1
            font-size 0.7rem
            line-height 1rem
          .title11
            margin-bottom 0.8rem
          .btn
            span
              font-size 0.34rem
            .icon-right
              width 0.26rem
              height 0.26rem
              // margin-top 0.1rem
        .right-item
          .item
            .icon
              width 1rem
              height 1rem
            .text
              margin-bottom 1rem
              .text1
                font-size 0.35rem
                margin-bottom 0.2rem
              .text2
                font-size 0.31rem
    .home-services
      width 100%
      padding 3rem 0
      .title1
        margin-bottom 1.4rem
      .list-box
        padding 0 0.5rem
        .left-list
          width 36%
          margin-right 0.8rem
          .item
            .name
              font-size 0.55rem
              margin-bottom 0.3rem
            .subname
              font-size 0.36rem
              line-height 0.5rem
        .right-info
          height 9rem
          padding 0.6rem
          .bg
            width 3.5rem
            height 3.5rem
          .title2
            font-size 0.6rem
            margin-bottom 0.6rem
          .subname
            font-size 0.4rem
            line-height 0.6rem
          .list
            margin-top 1rem
            .item
              margin-bottom 0.6rem
              font-size 0.4rem
              line-height 0.6rem
              .icon
                width 0.4rem
                height 0.32rem
                margin 0.1rem 0.2rem  0.1rem  0
    .home-global
      padding 2rem 0
      .bg
        width 28rem
        height 20rem
      .list
        width 100%
        margin 2rem 0.5rem 1rem 1rem
        .item
          margin-bottom 0.6rem
          .name
            font-size 0.5rem
            line-height 0.6rem
            margin-bottom 0.1rem
          .countries
            font-size 0.4rem
            line-height 0.6rem
        .active
          .countries
            font-size 0.5rem
    .home-price
      padding 2rem 0.5rem 4rem 0.5rem
      .price-box
        width 100%
        margin 0.8rem auto 0 auto
        .left-price
          .item
            padding 0.3rem 0 0.6rem 0
            margin-right 0.5rem
            .info-box
              .name-box
                .name
                  font-size 0.44rem
                .subname-box
                  .subname
                    font-size 0.34rem
              .describe
                font-size 0.36rem
              .p-box
                .type
                  font-size 0.34rem
                  width 1.4rem
                  height 0.56rem
                  line-height 0.56rem
                .usd
                  font-size 0.42rem
                .price1
                  font-size 0.85rem
                .price2
                  font-size 0.34rem
                .unit
                  font-size 0.32rem
            .btn-box
              .btn
                font-size 0.4rem
                padding 0 0.3rem
          .payType
            padding 0.3rem 0.5rem
            .title2
              font-size 0.4rem
              padding-right 0.5rem
              margin-right 0.5rem
            .img
              width 1rem
              height 1rem
              margin-right 0.5rem
        .right-contact
          width 5rem
          .text
            font-size 0.4rem
            line-height 0.6rem
          .btn
            font-size 0.36rem
    .home-chosen
      padding 0 0.5rem
      .title2
        font-size 0.4rem
        line-height 0.8rem
        padding 0 1rem
      .list
        width 100%
        margin 0 auto 3rem auto
        .item
          .name
            font-size 0.4rem
    .home-go
      font-size 0.5rem
      line-height 0.6rem
      padding 0.4rem 0
      .arrow
        width 0.45rem
        height 0.35rem
        margin-top 0.1rem
@media screen and (max-width: 800px)
  .miya-home
    .home-chosen, .home-price, .home-global, .home-services
      .title1
        width 80%
        font-size 1.1rem
        line-height 1.6rem
        margin 0 auto 1rem auto
    .home-hearder
      .logo
        display none
      .headMenu
        .list
          left 0
          transform none
          .item
            margin 0 0.5rem
            font-size 0.7rem
      .btns
        margin 18px 0.4rem
        .btn
          width 3rem
          font-size 0.6rem
        .goDashboard
          width 6rem
    .home-banner
      .banner
        display block
        .left-title
          width 100%
          margin-right 0.5rem
          .title1
            padding-top 2rem
            font-size 1rem
            line-height 1.8rem
            margin-bottom 0
          .title11
            padding-top 1rem
          .btn
            height 1.6rem
            padding 0.3rem 0.6rem
            span
              font-size 0.8rem
              line-height 1rem
              margin-right 0.6rem
            .icon-right
              width 0.6rem
              height 0.6rem
              margin-top 0.15rem
        .right-item
          padding-top 4rem
          .item
            .icon
              width 1.5rem
              height 1.5rem
              margin-right 0.5rem
            .text
              margin-bottom 1.2rem
              .text1
                font-size 0.65rem
                margin-bottom 0.1rem
                line-height 1rem
              .text2
                font-size 0.5rem
                line-height 0.8rem
    .home-services
      .list-box
        .left-list
          width 40%
          .item
            .name
              font-size 0.7rem
            .subname
              font-size 0.55rem
              line-height 0.7rem
        .right-info
          height 13rem
          .bg
            width 4rem
            height 4rem
            right 0.2rem
            bottom -0.2rem
          .title2
            font-size 0.9rem
          .subname
            font-size 0.7rem
            line-height 0.9rem
            height auto
          .list
            margin-top 1rem
            .item
              font-size 0.6rem
              line-height 0.8rem
              .icon
                width 0.6rem
                height 0.48rem
                margin 0.2rem 0.3rem  0.1rem  0
    .home-global
      padding 2rem 0
      .list
        margin 1rem 0.5rem 1rem 2rem
        .item
          margin-bottom 0.8rem
          .name
            font-size 0.7rem
            line-height 0.8rem
            margin-bottom 0.3rem
          .countries
            font-size 0.6rem
            line-height 0.7rem
        .active
          .countries
            font-size 0.7rem
    .home-price
      .price-box
        display block
        .left-price
          .item
            padding 0.4rem 0 1.6rem  0
            display block
            .info-box
              .name-box
                line-height 1.4rem
                .name
                  font-size 0.8rem
                .line
                  width 1px
                  height 1.4rem
                  margin 0 0.4rem
                .subname-box
                  height 1.4rem
                  padding-right 0.5rem
                  .subname
                    font-size 0.7rem
                  .icon
                    width 1rem
                    height 1rem
                    margin 0.2rem
              .describe
                font-size 0.7rem
                line-height 1.2rem
              .p-box
                line-height 1.1rem
                margin-bottom 0.5rem
                .type
                  font-size 0.6rem
                  width 2.8rem
                  height 1.1rem
                  line-height 1.1rem
                  margin-top -0.2rem
                .usd
                  font-size 0.9rem
                .price1
                  font-size 1.8rem
                .price2
                  font-size 0.8rem
                .unit
                  font-size 0.7rem
            .btn-box
              .btn
                font-size 0.9rem
                text-align center
                line-height 1.8rem
          .payType
            .title2
              font-size 0.7rem
              padding-right 0.5rem
              margin-right 0.5rem
              line-height 1.6rem
            .img
              width 1.6rem
              height 1.6rem
              margin-right 0.5rem
        .right-contact
          width 100%
          margin-top 1rem
          height 2rem
          .text
            font-size 0.6rem
            line-height 0.6rem
            left 0
            text-align left
            padding-left 0.5rem
            transform translate3d(0,-50%,0)
          .btn
            font-size 0.7rem
            width 5rem
            height 1.6rem
            transform none
            left auto
            line-height 1.6rem
            bottom 0.2rem
            right 0.5rem
    .home-chosen
      padding 0 0.5rem
      .title2
        font-size 0.7rem
        line-height 1rem
        padding 0 1rem
        margin 0.6rem 0 1.6rem 0
      .list
        width 100%
        margin 0 auto 3rem auto
        flex-wrap wrap
        .item
          width 50%
          flex auto
          margin-bottom 1.6rem
          .name
            font-size 0.8rem
          .img
            width 4rem
            height 4rem
    .home-go
      font-size 0.8rem
      line-height 1rem
      padding 0.6rem 0
      letter-spacing 0
      .arrow
        width 0.9rem
        height 0.7rem
</style>
